import React from 'react'
import classNames from 'classnames'
import { RadioGroup, RadioButton as RadioInput } from 'react-radio-buttons'
import styles from './RadioButton.module.scss'

const RadioButton = ({ options, onChange, state }) => {
  return (
    <div className={classNames(styles.container)}>
      <RadioGroup onChange={onChange}>
        {options.map(option => (
          <RadioInput
            value={option.name}
            rootColor="#101010"
            pointColor="#00af93"
          >
            {state === option.name ? (
              <strong className={styles.textStrong}>{option.label}</strong>
            ) : (
              option.label
            )}
          </RadioInput>
        ))}
      </RadioGroup>
    </div>
  )
}

export default React.memo(RadioButton)
